import React from 'react'

type Props = {
  width: string | number
  height: string | number
  fill?: string
}

const IconCheckCircleOn = ({ width, height, fill = '#09aa5c' }: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11" r="11" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.01324 15.4286C8.83241 15.4292 8.65866 15.3583 8.52981 15.2314L5.19981 11.9374C5.07198 11.8115 5 11.6395 5 11.46C5 11.2805 5.07198 11.1085 5.19981 10.9826C5.46774 10.7187 5.89789 10.7187 6.16581 10.9826L9.01324 13.7974L15.8335 7.05428C16.1015 6.79038 16.5316 6.79038 16.7995 7.05428C16.9276 7.18014 16.9997 7.35216 16.9997 7.53171C16.9997 7.71126 16.9276 7.88328 16.7995 8.00914L9.49667 15.2314C9.36796 15.3586 9.1942 15.4298 9.01324 15.4294"
        fill="white"
      />
    </svg>
  )
}

export default IconCheckCircleOn
